import React, { useState, useContext } from 'react'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { useReportScheduledEmails } from 'api/hooks/use-report-scheduled-emails'
import UserContext from 'context/user-context'
import ScheduleEmailModal from './schedule-email-modal'

function ScheduleEmailButton({ report, hideTrigger = false, show: controlledShow, setShow: controlledSetShow }) {
  const [internalShow, setInternalShow] = useState(false)
  const show = controlledShow !== undefined ? controlledShow : internalShow
  const setShow = controlledSetShow || setInternalShow
  const { data: emails } = useReportScheduledEmails({
    reportId: report?.id,
    params: {},
    options: { enabled: !!report?.id }
  })
  const user = useContext(UserContext)

  const isOwner = user.id === report?.user_id
  const isEditor = report?.shared_users?.find((ru) => ru.user_id === user.id)?.is_editor ?? false
  const canEdit = isOwner || isEditor

  if (!canEdit) {
    return ''
  }

  const count = emails?.data?.length || 0

  return (
    <>
      {!hideTrigger && (
        <Button
          variant="light"
          className="border d-flex align-items-center gap-2"
          onClick={() => setShow(true)}
        >
          <FontAwesomeIcon icon={faEnvelope} />
          Schedule
          {count > 0 && (
            <Badge bg="primary" pill>
              {count}
            </Badge>
          )}
        </Button>
      )}
      {show && (
        <ScheduleEmailModal
          show={show}
          handleClose={() => setShow(false)}
          report={report}
          emails={emails}
        />
      )}
    </>
  )
}

export default ScheduleEmailButton
